import React, { Component } from "react";































































































































































































































































import {































































































































































































































































  Button,































































































































































































































































  Container,































































































































































































































































  Row, Form,































































































































































































































































  Col,































































































































































































































































  Offcanvas,































































































































































































































































} from "react-bootstrap";































































































































































































































































import { toast } from "react-toastify";































































































































































































































































import DataTable from "react-data-table-component";































































































































































































































































import configData from '../config.json';































































































































































































































































import { ValidationUtils } from '../Sidebar/Common';































































































































































































































































































































































































































































































































import LoadingOverlay from "./LoadingOverlay";
export default class Rule_execution_queue extends Component {































































































































































































































































  constructor(props) {































































































































































































































































    super(props);































































































































































































































































    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",































































































































































































































































      show: false,































































































































































































































































      data: [],































































































































































































































































      sId: sessionStorage.getItem("sessionId"),































































































































































































































































      uId: sessionStorage.getItem("uId"),































































































































































































































































      errors: {},































































































































































































































































      touched: {}, // Track which fields have been touched































































































































































































































































      filteredData: null,































































































































































































































































      tableClms: [































































































































































































































































        {































































































































































































































































          name: "S.NO",































































































































































































































































          selector: (row, i) => row.rule_execution_queue_Id,































































































































































































































































          sortable: true,































































































































































































































































          cell: (row) => <span>{row.rule_execution_queue_Id}</span>,































































































































































































































































        },































































































































































































































































        { name: "Table Name", selector: (row, i) => row.table_name, sortable: true, cell: (row) => <span>{row.table_name}</span>, }, { name: "Trigger Event", selector: (row, i) => row.trigger_event, sortable: true, cell: (row) => <span>{row.trigger_event}</span>, }, { name: "Rule Id", selector: (row, i) => row.rule_id, sortable: true, cell: (row) => <span>{row.rule_id}</span>, }, { name: "Parameters", selector: (row, i) => row.parameters, sortable: true, cell: (row) => <span>{row.parameters}</span>, }, { name: "Priority", selector: (row, i) => row.priority, sortable: true, cell: (row) => <span>{row.priority}</span>, }, { name: "Status", selector: (row, i) => row.status, sortable: true, cell: (row) => <span>{row.status}</span>, }, { name: "Attempts", selector: (row, i) => row.attempts, sortable: true, cell: (row) => <span>{row.attempts}</span>, }, { name: "Result", selector: (row, i) => row.result, sortable: true, cell: (row) => <span>{row.result}</span>, }, { name: "Error Message", selector: (row, i) => row.error_message, sortable: true, cell: (row) => <span>{row.error_message}</span>, },































































































































































































































































        { name: "Trigger Rule Id", selector: (row, i) => row.trigger_rule_id, sortable: true, cell: (row) => <span>{row.trigger_rule_id}</span>, }, { name: "Record Id", selector: (row, i) => row.record_id, sortable: true, cell: (row) => <span>{row.record_id}</span>, }, { name: "Input Data", selector: (row, i) => row.input_data, sortable: true, cell: (row) => <span>{row.input_data}</span>, }, { name: "Scheduled Time", selector: (row, i) => row.scheduled_time, sortable: true, cell: (row) => <span>{row.scheduled_time}</span>, }, { name: "Started At", selector: (row, i) => row.started_at, sortable: true, cell: (row) => <span>{row.started_at}</span>, }, { name: "Completed At", selector: (row, i) => row.completed_at, sortable: true, cell: (row) => <span>{row.completed_at}</span>, }, { name: "Max Attempts", selector: (row, i) => row.max_attempts, sortable: true, cell: (row) => <span>{row.max_attempts}</span>, }, { name: "Result Data", selector: (row, i) => row.result_data, sortable: true, cell: (row) => <span>{row.result_data}</span>, },//***tableClms































































































































































































































































        {































































































































































































































































          name: "Actions",































































































































































































































































          sortable: false,































































































































































































































































          cell: (row) => (































































































































































































































































            <div>































































































































































































































































              {/* edit button and delete button */}































































































































































































































































              <Button































































































































































































































































                style={{ marginRight: "10px" }}































































































































































































































































                variant="primary"































































































































































































































































                onClick={() => this.Rule_execution_queueeditHandler(row)}































































































































































































































































                className="bi bi-pen"































































































































































































































































              >































































































































































































































































              </Button>































































































































































































































































              <Button































































































































































































































































                variant="danger"































































































































































































































































                onClick={() => this.handleDelete(row)}































































































































































































































































                className="bi bi-trash danger"































































































































































































































































              >































































































































































































































































              </Button>































































































































































































































































            </div>































































































































































































































































          ),































































































































































































































































        },































































































































































































































































      ],































































































































































































































































      currentPage: 1,































































































































































































































































      itemsPerPage: 10,































































































































































































































































      isEditing: false,































































































































































































































































      rule_execution_queue_Id: "",































































































































































































































































      table_name: '', trigger_event: '', rule_id: '', parameters: '', testcaseprioritymaster: [], priority: '', testcasestatusmaster: [], status: '', attempts: '', result: '', error_message: '',































































































































































































































































      trigger_rule_id: '', record_id: '', input_data: '', scheduled_time: '', started_at: '', completed_at: '', max_attempts: '', result_data: '',//***state































































































































































































































































    };































































































































































































































































  }































































































































































































































































































































































































































































































































  // Enhanced validation method using Common.js with auto-generated logic































































































































































































































































  validateField = (fieldName, value, fieldConfig) => {































































































































































































































































    const { inputType, validationOptions } = fieldConfig;































































































































































































































































    const fieldDisplayName = fieldConfig.displayName || fieldName;































































































































































































































































































































































































































































































































    let validationResult = { isValid: true, message: "" };































































































































































































































































































































































































































































































































    // Auto-generated validation based on inputType and validationOptions































































































































































































































































    switch (inputType.toLowerCase()) {































































































































































































































































      case 'text':































































































































































































































































        if (validationOptions?.isName) {































































































































































































































































          validationResult = ValidationUtils.validateName(value);































































































































































































































































        } else if (validationOptions?.isAddress) {































































































































































































































































          validationResult = ValidationUtils.validateAddress(value);































































































































































































































































        } else if (validationOptions?.maxLength) {































































































































































































































































          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);































































































































































































































































        } else {































































































































































































































































          validationResult = { isValid: true, message: "" };































































































































































































































































        }































































































































































































































































        break;































































































































































































































































































































































































































































































































      case 'mail':































































































































































































































































      case 'email':































































































































































































































































        validationResult = ValidationUtils.validateEmail(value);































































































































































































































































        break;































































































































































































































































































































































































































































































































      case 'telephone':































































































































































































































































      case 'phone':































































































































































































































































        validationResult = ValidationUtils.validatePhone(value);































































































































































































































































        break;































































































































































































































































































































































































































































































































      case 'number':































































































































































































































































        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);































































































































































































































































        break;































































































































































































































































































































































































































































































































      case 'dob_child':































































































































































































































































        validationResult = ValidationUtils.validateDOBMinAge(value);































































































































































































































































        break;































































































































































































































































































































































































































































































































      case 'dob_adult':































































































































































































































































        validationResult = ValidationUtils.validateDOBAdult(value);































































































































































































































































        break;































































































































































































































































































































































































































































































































      case 'pan':































































































































































































































































        validationResult = ValidationUtils.validatePAN(value);































































































































































































































































        break;































































































































































































































































































































































































































































































































      case 'aadhaar':































































































































































































































































        validationResult = ValidationUtils.validateAadhaar(value);































































































































































































































































        break;































































































































































































































































































































































































































































































































      case 'password':































































































































































































































































        if (value.length < 6) {































































































































































































































































          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };































































































































































































































































        }































































































































































































































































        break;































































































































































































































































































































































































































































































































      default:































































































































































































































































        validationResult = { isValid: true, message: "" };































































































































































































































































    }































































































































































































































































































































































































































































































































    // Check required field validation































































































































































































































































    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {































































































































































































































































      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);































































































































































































































































    }































































































































































































































































































































































































































































































































    const errors = { ...this.state.errors };































































































































































































































































    if (!validationResult.isValid) {































































































































































































































































      errors[fieldName] = validationResult.message;































































































































































































































































    } else {































































































































































































































































      delete errors[fieldName];































































































































































































































































    }































































































































































































































































































































































































































































































































    this.setState({ errors });































































































































































































































































    return validationResult.isValid;































































































































































































































































  };































































































































































































































































































































































































































































































































  // Enhanced field change handler with auto-validation































































































































































































































































  handleFieldChange = (fieldName, value, fieldConfig) => {































































































































































































































































    this.setState({































































































































































































































































      [fieldName]: value,































































































































































































































































      touched: { ...this.state.touched, [fieldName]: true }































































































































































































































































    });































































































































































































































































































































































































































































































































    // Only validate if field has been touched































































































































































































































































    if (this.state.touched[fieldName] || value !== "") {































































































































































































































































      this.validateField(fieldName, value, fieldConfig);































































































































































































































































    }































































































































































































































































  };































































































































































































































































































































































































































































































































  // Enhanced field blur handler for validation































































































































































































































































  handleFieldBlur = (fieldName, value, fieldConfig) => {































































































































































































































































    this.setState({































































































































































































































































      touched: { ...this.state.touched, [fieldName]: true }































































































































































































































































    });































































































































































































































































    this.validateField(fieldName, value, fieldConfig);































































































































































































































































  };































































































































































































































































































































































































































































































































  // Check if form is valid - auto-generated based on required fields































































































































































































































































  isFormValid = () => {































































































































































































































































    const { errors } = this.state;































































































































































































































































































































































































































































































































    // Auto-generated required field validation































































































































































































































































    // Auto-generated required field validation































































































































































































































































    const requiredFields = ['table_name', 'trigger_event', 'parameters'];































































































































































































































































    for (const field of requiredFields) {































































































































































































































































      if (!this.state[field] || this.state[field].toString().trim() === '') {































































































































































































































































        return false;































































































































































































































































      }































































































































































































































































    }































































































































































































































































































































































































































































































































































































































































































































































































    return Object.keys(errors).length === 0;































































































































































































































































  };































































































































































































































































































































































































































































































































  // Auto-generated validation for all fields before submission































































































































































































































































  validateAllFields = () => {































































































































































































































































    const fieldConfigs = [































































































































































































































































      { fieldName: 'table_name', inputType: 'Text', displayName: 'Table Name', validationOptions: { isRequired: true, maxLength: 100 } },































































































































































































































































      { fieldName: 'trigger_event', inputType: 'Text', displayName: 'Trigger Event', validationOptions: { isRequired: true, maxLength: 50 } },































































































































































































































































      { fieldName: 'rule_id', inputType: 'Number', displayName: 'Rule Id', validationOptions: { isRequired: false } },































































































































































































































































      { fieldName: 'parameters', inputType: 'Text', displayName: 'Parameters', validationOptions: { isRequired: true, maxLength: 100 } },































































































































































































































































      { fieldName: 'priority', inputType: 'Select', displayName: 'Priority', validationOptions: { isRequired: false } },































































































































































































































































      { fieldName: 'status', inputType: 'Select', displayName: 'Status', validationOptions: { isRequired: false } },































































































































































































































































      { fieldName: 'attempts', inputType: 'Number', displayName: 'Attempts', validationOptions: { isRequired: false } },































































































































































































































































      { fieldName: 'result', inputType: 'Text', displayName: 'Result', validationOptions: { isRequired: false } },































































































































































































































































      { fieldName: 'error_message', inputType: 'Text', displayName: 'Error Message', validationOptions: { isRequired: false } }































































































































































































































































    ];































































































































































































































































































































































































































































































































    fieldConfigs.forEach(config => {































































































































































































































































      const value = this.state[config.fieldName];































































































































































































































































      this.validateField(config.fieldName, value, config);































































































































































































































































    });































































































































































































































































































































































































































































































































    const touched = {};































































































































































































































































    fieldConfigs.forEach(config => {































































































































































































































































      touched[config.fieldName] = true;































































































































































































































































    });































































































































































































































































    this.setState({ touched });































































































































































































































































































































































































































































































































  };































































































































































































































































































































































































































































































































  // offcanvas Open































































































































































































































































  handleOffcanvasShow = () => {































































































































































































































































    this.setState({































































































































































































































































      show: true,































































































































































































































































      errors: {},































































































































































































































































      touched: {},































































































































































































































































      table_name: '', trigger_event: '', rule_id: '', parameters: '', testcaseprioritymaster: [], priority: '', testcasestatusmaster: [], status: '', attempts: '', result: '', error_message: '',































































































































































































































































    });































































































































































































































































  };































































































































































































































































































































































































































































































































  // Offcanvas close button































































































































































































































































  handleOffcanvasClose = () => {































































































































































































































































    this.setState({































































































































































































































































      show: false,































































































































































































































































      isEditing: false,































































































































































































































































      errors: {},































































































































































































































































      touched: {},































































































































































































































































      table_name: '', trigger_event: '', rule_id: '', parameters: '', testcaseprioritymaster: [], priority: '', testcasestatusmaster: [], status: '', attempts: '', result: '', error_message: '',































































































































































































































































    });































































































































































































































































  };































































































































































































































































































































































































































































































































  // Enhanced toast notifications































































































































































































































































  showToast = (msg, type) => {































































































































































































































































    switch (type) {































































































































































































































































      case "success":































































































































































































































































        toast.success(msg);































































































































































































































































        break;































































































































































































































































      case "error":































































































































































































































































        toast.error(msg);































































































































































































































































        break;































































































































































































































































      case "warning":































































































































































































































































        toast.warn(msg);































































































































































































































































        break;































































































































































































































































      default:































































































































































































































































        toast.info(msg);































































































































































































































































    }































































































































































































































































  };































































































































































































































































































































































































































































































































  Rule_execution_queueeditHandler = (row) => {































































































































































































































































    this.setState({































































































































































































































































      isEditing: true,































































































































































































































































      show: true,































































































































































































































































      rule_execution_queue_Id: row.rule_execution_queue_Id,































































































































































































































































      table_name: row.table_name, trigger_event: row.trigger_event, rule_id: row.rule_id, parameters: row.parameters, testcaseprioritymaster: [], priority: row.priority, testcasestatusmaster: [], status: row.status, attempts: row.attempts, result: row.result, error_message: row.error_message,































































































































































































































































      trigger_rule_id: row.trigger_rule_id, record_id: row.record_id, input_data: row.input_data, scheduled_time: row.scheduled_time, started_at: row.started_at, completed_at: row.completed_at, max_attempts: row.max_attempts, result_data: row.result_data,//***editstate































































































































































































































































      errors: {},































































































































































































































































      touched: {}































































































































































































































































    });































































































































































































































































  }































































































































































































































































































































































































































































































































  Rule_execution_queuefetchHandler = () => {































































































































































































































































    var formData = new FormData();































































































































































































































































    formData.append("sId", this.state.sId);































































































































































































































































    formData.append("uId", this.state.uId);































































































































































































































































































































































































































































































































    fetch(configData.api_url + 'C_Rule_execution_queue/list', {































































































































































































































































      method: 'POST',































































































































































































































































      mode: 'cors',































































































































































































































































      body: formData































































































































































































































































    })































































































































































































































































      .then(response => response.json())































































































































































































































































      .then((data) => {































































































































































































































































        if (data.status === "success") {































































































































































































































































          this.setState({ data: data.list });































































































































































































































































        }































































































































































































































































      })































































































































































































































































      .catch((error) => {































































































































































































































































        console.error("Fetch error:", error);































































































































































































































































        this.showToast("Failed to load data", "error");































































































































































































































































      });































































































































































































































































  }































































































































































































































































































































































































































































































































  Rule_execution_queuesubmitHandler = (e) => {































































































































































































































































    e.preventDefault();































































































































































































































































































































































































































































































































    // Validate all fields before submission































































































































































































































































    this.validateAllFields();































































































































































































































































































































































































































































































































    if (!this.isFormValid()) {































































































































































































































































      this.showToast("Please fix all errors before submitting", "error");































































































































































































































































      return;































































































































































































































































    }































































































































































































































































































































































































































































































































    var formData = new FormData();































































































































































































































































    formData.append("sId", this.state.sId);































































































































































































































































    formData.append("uId", this.state.uId);































































































































































































































































    formData.append('table_name', this.state.table_name);































































































































































































































































    formData.append('trigger_event', this.state.trigger_event);































































































































































































































































    formData.append('rule_id', this.state.rule_id);































































































































































































































































    formData.append('parameters', this.state.parameters);































































































































































































































































    formData.append('priority', this.state.priority);































































































































































































































































    formData.append('status', this.state.status);































































































































































































































































    formData.append('attempts', this.state.attempts);































































































































































































































































    formData.append('result', this.state.result);































































































































































































































































    formData.append('error_message', this.state.error_message);































































































































































































































































































































































































































































































































    formData.append('trigger_rule_id', this.state.trigger_rule_id);































































































































    formData.append('record_id', this.state.record_id);































































    formData.append('input_data', this.state.input_data);































    formData.append('scheduled_time', this.state.scheduled_time);















    formData.append('started_at', this.state.started_at);







    formData.append('completed_at', this.state.completed_at);



    formData.append('max_attempts', this.state.max_attempts);

    formData.append('result_data', this.state.result_data);
    //***tableData*































































































































































































































































































































































































































































































































    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Rule_execution_queue/add', {































































































































































































































































      method: 'POST',































































































































































































































































      mode: 'cors',































































































































































































































































      body: formData































































































































































































































































    })































































































































































































































































      .then(response => response.json())































































































































































































































































      .then((data) => {































































































































































































































































        this.showToast(data.message, data.status);































































































































































































































































        if (data.status === "success") {































































































































































































































































          this.Rule_execution_queuefetchHandler();































































































































































































































































          this.handleOffcanvasClose();































































































































































































































































          this.setState({ table_name: '', trigger_event: '', rule_id: '', parameters: '', testcaseprioritymaster: [], priority: '', testcasestatusmaster: [], status: '', attempts: '', result: '', error_message: '', });































































































































































































































































        }































































































































































































































































      
        this.setState({ loading: false });})































































































































































































































































      .catch((error) => {































































































































































































































































        console.error("Submit error:", error);































































































































































































































































        this.showToast("Failed to save data", "error");































































































































































































































































      
        this.setState({ loading: false });});































































































































































































































































  }































































































































































































































































































































































































































































































































  Rule_execution_queueupdateHandler = (e) => {































































































































































































































































    e.preventDefault();































































































































































































































































































































































































































































































































    // Validate all fields before submission































































































































































































































































    this.validateAllFields();































































































































































































































































































































































































































































































































    if (!this.isFormValid()) {































































































































































































































































      this.showToast("Please fix all errors before updating", "error");































































































































































































































































      return;































































































































































































































































    }































































































































































































































































































































































































































































































































    var formData = new FormData();































































































































































































































































    formData.append("sId", this.state.sId);































































































































































































































































    formData.append("uId", this.state.uId);































































































































































































































































    formData.append("rule_execution_queue_Id", this.state.rule_execution_queue_Id);































































































































































































































































    formData.append('table_name', this.state.table_name);































































































































































































































































    formData.append('trigger_event', this.state.trigger_event);































































































































































































































































    formData.append('rule_id', this.state.rule_id);































































































































































































































































    formData.append('parameters', this.state.parameters);































































































































































































































































    formData.append('priority', this.state.priority);































































































































































































































































    formData.append('status', this.state.status);































































































































































































































































    formData.append('attempts', this.state.attempts);































































































































































































































































    formData.append('result', this.state.result);































































































































































































































































    formData.append('error_message', this.state.error_message);































































































































































































































































































































































































































































































































    formData.append('trigger_rule_id', this.state.trigger_rule_id);































































































































    formData.append('record_id', this.state.record_id);































































    formData.append('input_data', this.state.input_data);































    formData.append('scheduled_time', this.state.scheduled_time);















    formData.append('started_at', this.state.started_at);







    formData.append('completed_at', this.state.completed_at);



    formData.append('max_attempts', this.state.max_attempts);

    formData.append('result_data', this.state.result_data);
    //***tableData1































































































































































































































































































































































































































































































































    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Rule_execution_queue/update', {































































































































































































































































      method: 'POST',































































































































































































































































      mode: 'cors',































































































































































































































































      body: formData































































































































































































































































    })































































































































































































































































      .then(response => response.json())































































































































































































































































      .then((data) => {































































































































































































































































        this.showToast(data.message, data.status);































































































































































































































































        if (data.status === "success") {































































































































































































































































          this.Rule_execution_queuefetchHandler();































































































































































































































































          this.handleOffcanvasClose();































































































































































































































































        }































































































































































































































































      
        this.setState({ loading: false });})































































































































































































































































      .catch((error) => {































































































































































































































































        console.error("Update error:", error);































































































































































































































































        this.showToast("Failed to update data", "error");































































































































































































































































      
        this.setState({ loading: false });});































































































































































































































































  }































































































































































































































































































































































































































































































































  componentDidMount() {































































































































































































































































    this.Rule_execution_queuefetchHandler();































































































































































































































































    this.testcaseprioritymasterfetchHandler();































































































































































































































































    this.testcasestatusmasterfetchHandler();































































































































































































































































































































































































































































































































    //***componentDidMount































































































































































































































































  }































































































































































































































































































































































































































































































































  handletable_nameChange = (e) => {































































































































































































































































    e.preventDefault();































































































































































































































































    const fieldValue = e.target.value;































































































































































































































































    this.setState({ table_name: fieldValue });































































































































































































































































  }; handletrigger_eventChange = (e) => {































































































































































































































































    e.preventDefault();































































































































































































































































    const fieldValue = e.target.value;































































































































































































































































    this.setState({ trigger_event: fieldValue });































































































































































































































































  }; handlerule_idChange = (e) => {































































































































































































































































    e.preventDefault();































































































































































































































































    const fieldValue = e.target.value;































































































































































































































































    this.setState({ rule_id: fieldValue });































































































































































































































































  }; handleparametersChange = (e) => {































































































































































































































































    e.preventDefault();































































































































































































































































    const fieldValue = e.target.value;































































































































































































































































    this.setState({ parameters: fieldValue });































































































































































































































































  }; handlepriorityChange = (e) => {































































































































































































































































    e.preventDefault();































































































































































































































































































































































































































































































































    const fieldValue = e.target.value;































































































































































































































































    this.setState({ priority: fieldValue });































































































































































































































































  }; testcaseprioritymasterfetchHandler = () => {































































































































































































































































    fetch(configData.api_url + "C_Testcaseprioritymaster/list", {  // Enter your IP address here































































































































































































































































      method: "POST",































































































































































































































































      mode: "cors",































































































































































































































































      body: {}// body data type must match "Content-Type" header































































































































































































































































    }).then(response => response.json())































































































































































































































































      .then((data) => {































































































































































































































































        if (data.status === "success") {































































































































































































































































          this.setState({ testcaseprioritymaster: data.list });































































































































































































































































        }































































































































































































































































      });































































































































































































































































  }; handlestatusChange = (e) => {































































































































































































































































    e.preventDefault();































































































































































































































































































































































































































































































































    const fieldValue = e.target.value;































































































































































































































































    this.setState({ status: fieldValue });































































































































































































































































  }; testcasestatusmasterfetchHandler = () => {































































































































































































































































    fetch(configData.api_url + "C_Testcasestatusmaster/list", {  // Enter your IP address here































































































































































































































































      method: "POST",































































































































































































































































      mode: "cors",































































































































































































































































      body: {}// body data type must match "Content-Type" header































































































































































































































































    }).then(response => response.json())































































































































































































































































      .then((data) => {































































































































































































































































        if (data.status === "success") {































































































































































































































































          this.setState({ testcasestatusmaster: data.list });































































































































































































































































        }































































































































































































































































      });































































































































































































































































  }; handleattemptsChange = (e) => {































































































































































































































































    e.preventDefault();































































































































































































































































    const fieldValue = e.target.value;































































































































































































































































    this.setState({ attempts: fieldValue });































































































































































































































































  }; handleresultChange = (e) => {































































































































































































































































    e.preventDefault();































































































































































































































































    const fieldValue = e.target.value;































































































































































































































































    this.setState({ result: fieldValue });































































































































































































































































  }; handleerror_messageChange = (e) => {































































































































































































































































    e.preventDefault();































































































































































































































































    const fieldValue = e.target.value;































































































































































































































































    this.setState({ error_message: fieldValue });































































































































































































































































  };































































































































































































































































  handletrigger_rule_idChange = (e) => {































































































































    e.preventDefault();































































































































    const fieldValue = e.target.value;































































































































    this.setState({ trigger_rule_id: fieldValue });































































































































  }; handlerecord_idChange = (e) => {































































    e.preventDefault();































































    const fieldValue = e.target.value;































































    this.setState({ record_id: fieldValue });































































  }; handleinput_dataChange = (e) => {































    e.preventDefault();































    const fieldValue = e.target.value;































    this.setState({ input_data: fieldValue });































  }; handlescheduled_timeChange = (e) => {















    e.preventDefault();































    const fieldValue = e.target.value;















    this.setState({ scheduled_time: fieldValue });















  }; handlestarted_atChange = (e) => {







    e.preventDefault();















    const fieldValue = e.target.value;







    this.setState({ started_at: fieldValue });







  }; handlecompleted_atChange = (e) => {



    e.preventDefault();







    const fieldValue = e.target.value;



    this.setState({ completed_at: fieldValue });



  }; handlemax_attemptsChange = (e) => {

    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ max_attempts: fieldValue });

  }; handleresult_dataChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ result_data: fieldValue });
  };//***inputFunctions































































































































































































































































































































































































































































































































  handleRowSelect = (row) => {































































































































































































































































    this.setState({































































































































































































































































      selectedRow: row.index,































































































































































































































































    });































































































































































































































































  };































































































































































































































































































































































































































































































































  handleRowUpdate = (newData, oldData) => {































































































































































































































































    const data = [...this.state.data];































































































































































































































































    const index = oldData.index;































































































































































































































































    data[index] = newData;































































































































































































































































    this.setState({ data });































































































































































































































































  };































































































































































































































































































































































































































































































































  handleEdit = (row) => {































































































































































































































































    console.log(`Editing row with ID ${row.id}`);































































































































































































































































  };































































































































































































































































































































































































































































































































  handleDelete = (row, index) => {































































































































































































































































    if (!window.confirm(`Are you sure you want to delete this rule_execution_queue?`)) {































































































































































































































































      return;































































































































































































































































    }































































































































































































































































































































































































































































































































    var formData = new FormData();































































































































































































































































    formData.append('rule_execution_queue_Id', row.rule_execution_queue_Id);































































































































































































































































































































































































































































































































    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Rule_execution_queue/delete', {































































































































































































































































      method: 'POST',































































































































































































































































      mode: 'cors',































































































































































































































































      body: formData































































































































































































































































    })































































































































































































































































      .then(response => response.json())































































































































































































































































      .then((data) => {































































































































































































































































        this.showToast(data.message, data.status);































































































































































































































































        if (data.status === "success") {































































































































































































































































          this.Rule_execution_queuefetchHandler();































































































































































































































































        }































































































































































































































































      
        this.setState({ loading: false });})































































































































































































































































      .catch((error) => {































































































































































































































































        console.error("Delete error:", error);































































































































































































































































        this.showToast("Failed to delete data", "error");































































































































































































































































      
        this.setState({ loading: false });});































































































































































































































































  };































































































































































































































































































































































































































































































































  handlePageChange = (page) => {































































































































































































































































    this.setState({ currentPage: page });































































































































































































































































  };































































































































































































































































































































































































































































































































  handlePerRowsChange = (newPerPage, page) => {































































































































































































































































    this.setState({ itemsPerPage: newPerPage, currentPage: page });































































































































































































































































  };































































































































































































































































































































































































































































































































  handleFilter = (e) => {































































































































































































































































    const searchValue = e.target.value.toLowerCase();































































































































































































































































    const filteredData = this.state.data.filter((row) => {































































































































































































































































      return Object.values(row).join(" ").toLowerCase().includes(searchValue);































































































































































































































































    });































































































































































































































































    this.setState({ filteredData });































































































































































































































































  };































































































































































































































































































































































































































































































































  // Helper method to render error message































































































































































































































































  renderFieldError = (fieldName) => {































































































































































































































































    const { errors, touched } = this.state;































































































































































































































































    if (errors[fieldName] && touched[fieldName]) {































































































































































































































































      return (































































































































































































































































        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>































































































































































































































































          <i className="bi bi-exclamation-circle me-1"></i>































































































































































































































































          {errors[fieldName]}































































































































































































































































        </div>































































































































































































































































      );































































































































































































































































    }































































































































































































































































    return null;































































































































































































































































  };































































































































































































































































































































































































































































































































  // Auto-generated form field renderer based on inputType and validation options































































































































































































































































  renderFormField = (fieldConfig) => {































































































































































































































































    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;































































































































































































































































    const value = this.state[fieldName] || "";































































































































































































































































    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];































































































































































































































































































































































































































































































































    let inputElement;































































































































































































































































































































































































































































































































    switch (inputType.toLowerCase()) {































































































































































































































































      case 'dob_child':































































































































































































































































      case 'dob_adult':































































































































































































































































      case 'date':































































































































































































































































        inputElement = (































































































































































































































































          <Form.Control































































































































































































































































            type="date"































































































































































































































































            value={value}































































































































































































































































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}































































































































































































































































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































































































































































































































































            isInvalid={hasError}































































































































































































































































            required={validationOptions?.isRequired}































































































































































































































































          />































































































































































































































































        );































































































































































































































































        break;































































































































































































































































































































































































































































































































      case 'telephone':































































































































































































































































      case 'phone':































































































































































































































































        inputElement = (































































































































































































































































          <Form.Control































































































































































































































































            type="tel"































































































































































































































































            value={value}































































































































































































































































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}































































































































































































































































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































































































































































































































































            isInvalid={hasError}































































































































































































































































            required={validationOptions?.isRequired}































































































































































































































































            placeholder="Enter 10-digit mobile number"































































































































































































































































          />































































































































































































































































        );































































































































































































































































        break;































































































































































































































































































































































































































































































































      case 'mail':































































































































































































































































      case 'email':































































































































































































































































        inputElement = (































































































































































































































































          <Form.Control































































































































































































































































            type="email"































































































































































































































































            value={value}































































































































































































































































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}































































































































































































































































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































































































































































































































































            isInvalid={hasError}































































































































































































































































            required={validationOptions?.isRequired}































































































































































































































































            placeholder="Enter email address"































































































































































































































































          />































































































































































































































































        );































































































































































































































































        break;































































































































































































































































































































































































































































































































      case 'password':































































































































































































































































        inputElement = (































































































































































































































































          <Form.Control































































































































































































































































            type="password"































































































































































































































































            value={value}































































































































































































































































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}































































































































































































































































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































































































































































































































































            isInvalid={hasError}































































































































































































































































            required={validationOptions?.isRequired}































































































































































































































































            placeholder="Enter password"































































































































































































































































          />































































































































































































































































        );































































































































































































































































        break;































































































































































































































































































































































































































































































































      case 'number':































































































































































































































































        inputElement = (































































































































































































































































          <Form.Control































































































































































































































































            type="number"































































































































































































































































            value={value}































































































































































































































































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}































































































































































































































































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































































































































































































































































            isInvalid={hasError}































































































































































































































































            required={validationOptions?.isRequired}































































































































































































































































            placeholder={`Enter ${displayName.toLowerCase()}`}































































































































































































































































          />































































































































































































































































        );































































































































































































































































        break;































































































































































































































































































































































































































































































































      case 'pan':































































































































































































































































        inputElement = (































































































































































































































































          <Form.Control































































































































































































































































            type="text"































































































































































































































































            value={value}































































































































































































































































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}































































































































































































































































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































































































































































































































































            isInvalid={hasError}































































































































































































































































            required={validationOptions?.isRequired}































































































































































































































































            placeholder="ABCPA1234B"































































































































































































































































            maxLength="10"































































































































































































































































          />































































































































































































































































        );































































































































































































































































        break;































































































































































































































































































































































































































































































































      case 'aadhaar':































































































































































































































































        inputElement = (































































































































































































































































          <Form.Control































































































































































































































































            type="text"































































































































































































































































            value={value}































































































































































































































































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}































































































































































































































































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































































































































































































































































            isInvalid={hasError}































































































































































































































































            required={validationOptions?.isRequired}































































































































































































































































            placeholder="123456789012"































































































































































































































































            maxLength="12"































































































































































































































































          />































































































































































































































































        );































































































































































































































































        break;































































































































































































































































































































































































































































































































      default: // text and other types































































































































































































































































        inputElement = (































































































































































































































































          <Form.Control































































































































































































































































            type="text"































































































































































































































































            value={value}































































































































































































































































            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}































































































































































































































































            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}































































































































































































































































            isInvalid={hasError}































































































































































































































































            required={validationOptions?.isRequired}































































































































































































































































            placeholder={`Enter ${displayName.toLowerCase()}`}































































































































































































































































            maxLength={validationOptions?.maxLength || undefined}































































































































































































































































          />































































































































































































































































        );































































































































































































































































    }































































































































































































































































































































































































































































































































    return (































































































































































































































































      <Row key={fieldName}>































































































































































































































































        <Col lg="4" md="4">































































































































































































































































          <Form.Label>































































































































































































































































            {displayName}































































































































































































































































            {validationOptions?.isRequired && <span className="text-danger">*</span>}































































































































































































































































          </Form.Label>































































































































































































































































        </Col>































































































































































































































































        <Col lg="8" md="8">































































































































































































































































          {inputElement}































































































































































































































































          {this.renderFieldError(fieldName)}































































































































































































































































        </Col>































































































































































































































































      </Row>































































































































































































































































    );































































































































































































































































  };































































































































































































































































































































































































































































































































  render() {































































































































































































































































    const { errors, touched } = this.state;































































































































































































































































































































































































































































































































    const paginatedData = this.state.filteredData































































































































































































































































      ? this.state.filteredData.slice(































































































































































































































































        (this.state.currentPage - 1) * this.state.itemsPerPage,































































































































































































































































        this.state.currentPage * this.state.itemsPerPage































































































































































































































































      )































































































































































































































































      : this.state.data.slice(































































































































































































































































        (this.state.currentPage - 1) * this.state.itemsPerPage,































































































































































































































































        this.state.currentPage * this.state.itemsPerPage































































































































































































































































      );































































































































































































































































































































































































































































































































    return (































































































































































































































































      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />































































































































































































































































        <div className="row">































































































































































































































































          <div className="col-md-12 col-sm-12 col-xs-12">































































































































































































































































            <div className="x_panel">































































































































































































































































              <div className="x_content">































































































































































































































































                <div































































































































































































































































                  id="datatable_wrapper"































































































































































































































































                  className="dataTables_wrapper form-inline































































































































































































































































                dt-bootstrap no-footer"































































































































































































































































                >































































































































































































































































                  <Row className="row">































































































































































































































































                    <div>































































































































































































































































                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Rule Execution Queue</h3>































































































































































































































































                    </div>































































































































































































































































                    <Col































































































































































































































































                      className="d-flex justify-content-end"































































































































































































































































                      style={{ marginRight: "5px", marginTop: "20px" }}































































































































































































































































                    >































































































































































































































































                      <Button































































































































































































































































                        variant="primary" style={{ float: "right", marginBottom: "10px" }}































































































































































































































































                        className="bi bi-plus "































































































































































































































































                        onClick={this.handleOffcanvasShow}































































































































































































































































                      >































































































































































































































































                        New































































































































































































































































                      </Button>































































































































































































































































































































































































































































































































                      {/* Enhanced Add Offcanvas */}































































































































































































































































                      <Offcanvas































































































































































































































































                        show={this.state.show && !this.state.isEditing}































































































































































































































































                        onHide={this.handleOffcanvasClose}































































































































































































































































                        {...this.props}































































































































































































































































                        style={{ width: "500px" }}































































































































































































































































                        placement="end"































































































































































































































































                        backdrop="true"































































































































































































































































                      >































































































































































































































































                        <Offcanvas.Header closeButton>































































































































































































































































                          <Offcanvas.Title>Add Rule_execution_queue</Offcanvas.Title>































































































































































































































































                        </Offcanvas.Header>































































































































































































































































                        <Offcanvas.Body>































































































































































































































































                          <Container style={{ "overflowY": "auto", height: "auto" }}>































































































































































































































































































































































































































































































































                            {/* Error Summary */}































































































































































































































































                            {Object.keys(errors).length > 0 && (































































































































































































































































                              <div className="alert alert-danger mb-3">































































































































































































































































                                <strong>Please fix the following errors:</strong>































































































































































































































































                                <ul className="mb-0 mt-2">































































































































































































































































                                  {Object.entries(errors).map(([field, error]) => (































































































































































































































































                                    <li key={field}>{error}</li>































































































































































































































































                                  ))}































































































































































































































































                                </ul>































































































































































































































































                              </div>































































































































































































































































                            )}































































































































































































































































































































































































































































































































                            <Row className="divstyle">































































































































































































































































                              <Row>































































































































































































































































                                <Form>































































































































































































































































                                  <Row>































































































































































































































































                                    <Col lg="4" md="4">































































































































































































































































                                      <Form.Label style={{ paddingTop: "8px" }}>Table Name</Form.Label>































































































































































































































































                                    </Col>































































































































































































































































                                    <Col lg="8" md="8">































































































































































































































































                                      <Form.Control type="text" onChange={this.handletable_nameChange} className="form-control" name="table_name" value={this.state.table_name} required="required" placeholder="Enter Table Name" />































































































































































































































































                                    </Col>































































































































































































































































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.table_name} </div>































































































































































































































































                                  </Row><br /><Row>































































































































































































































































                                    <Col lg="4" md="4">































































































































































































































































                                      <Form.Label style={{ paddingTop: "8px" }}>Trigger Event</Form.Label>































































































































































































































































                                    </Col>































































































































































































































































                                    <Col lg="8" md="8">































































































































































































































































                                      <Form.Control type="text" onChange={this.handletrigger_eventChange} className="form-control" name="trigger_event" value={this.state.trigger_event} required="required" placeholder="Enter Trigger Event" />































































































































































































































































                                    </Col>































































































































































































































































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.trigger_event} </div>































































































































































































































































                                  </Row><br /><Row>































































































































































































































































                                    <Col lg="4" md="4">































































































































































































































































                                      <Form.Label style={{ paddingTop: "8px" }}>Rule Id</Form.Label>































































































































































































































































                                    </Col>































































































































































































































































                                    <Col lg="8" md="8">































































































































































































































































                                      <Form.Control type="number" onChange={this.handlerule_idChange} className="form-control" name="rule_id" value={this.state.rule_id} required="required" placeholder="Enter Rule Id" />































































































































































































































































                                    </Col>































































































































































































































































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.rule_id} </div>































































































































































































































































                                  </Row><br /><Row>































































































































































































































































                                    <Col lg="4" md="4">































































































































































































































































                                      <Form.Label style={{ paddingTop: "8px" }}>Parameters</Form.Label>































































































































































































































































                                    </Col>































































































































































































































































                                    <Col lg="8" md="8">































































































































































































































































                                      <Form.Control type="text" onChange={this.handleparametersChange} className="form-control" name="parameters" value={this.state.parameters} required="required" placeholder="Enter Parameters" />































































































































































































































































                                    </Col>































































































































































































































































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.parameters} </div>































































































































































































































































                                  </Row><br /><Row>































































































































































































































































                                    <Col lg="4" md="4">































































































































































































































































                                      <Form.Label style={{ paddingTop: "8px" }}>Priority</Form.Label>































































































































































































































































                                    </Col>































































































































































































































































                                    <Col lg="8" md="8">































































































































































































































































                                      <select className="form-select" name="tableName" onChange={this.handlepriorityChange}>































































































































































































































































                                        <option defaultValue> Select Priority </option>































































































































































































































































                                        {this.state.testcaseprioritymaster.map((api, index, idx) => (































































































































































































































































                                          <option key={index} value={api.low}> {api.low} </option>































































































































































































































































                                        ))}































































































































































































































































                                      </select>































































































































































































































































                                    </Col>































































































































































































































































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.priority} </div>































































































































































































































































                                  </Row><br /><Row>































































































































































































































































                                    <Col lg="4" md="4">































































































































































































































































                                      <Form.Label style={{ paddingTop: "8px" }}>Status</Form.Label>































































































































































































































































                                    </Col>































































































































































































































































                                    <Col lg="8" md="8">































































































































































































































































                                      <select className="form-select" name="tableName" onChange={this.handlestatusChange}>































































































































































































































































                                        <option defaultValue> Select Status </option>































































































































































































































































                                        {this.state.testcasestatusmaster.map((api, index, idx) => (































































































































































































































































                                          <option key={index} value={api.pending}> {api.pending} </option>































































































































































































































































                                        ))}































































































































































































































































                                      </select>































































































































































































































































                                    </Col>































































































































































































































































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.status} </div>































































































































































































































































                                  </Row><br /><Row>































































































































































































































































                                    <Col lg="4" md="4">































































































































































































































































                                      <Form.Label style={{ paddingTop: "8px" }}>Attempts</Form.Label>































































































































































































































































                                    </Col>































































































































































































































































                                    <Col lg="8" md="8">































































































































































































































































                                      <Form.Control type="number" onChange={this.handleattemptsChange} className="form-control" name="attempts" value={this.state.attempts} required="required" placeholder="Enter Attempts" />































































































































































































































































                                    </Col>































































































































































































































































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.attempts} </div>































































































































































































































































                                  </Row><br /><Row>































































































































































































































































                                    <Col lg="4" md="4">































































































































































































































































                                      <Form.Label style={{ paddingTop: "8px" }}>Result</Form.Label>































































































































































































































































                                    </Col>































































































































































































































































                                    <Col lg="8" md="8">































































































































































































































































                                      <Form.Control type="text" onChange={this.handleresultChange} className="form-control" name="result" value={this.state.result} required="required" placeholder="Enter Result" />































































































































































































































































                                    </Col>































































































































































































































































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.result} </div>































































































































































































































































                                  </Row><br /><Row>































































































































































































































































                                    <Col lg="4" md="4">































































































































































































































































                                      <Form.Label style={{ paddingTop: "8px" }}>Error Message</Form.Label>































































































































































































































































                                    </Col>































































































































































































































































                                    <Col lg="8" md="8">































































































































































































































































                                      <Form.Control type="text" onChange={this.handleerror_messageChange} className="form-control" name="error_message" value={this.state.error_message} required="required" placeholder="Enter Error Message" />































































































































































































































































                                    </Col>































































































































































































































































                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.error_message} </div>































































































































































































































































                                  </Row><br />































































































































































































































































                                  {/* Auto-generated form content with validation */}































































































































































































































































                                </Form>































































































































































































































































                              </Row>































































































































































































































































                            </Row>































































































































































































































































                            <Row>































































































































































































































































                              <Col































































































































































































































































                                className="d-flex justify-content-end"































































































































































































































































                                style={{ marginRight: "50px" }}































































































































































































































































                              >































































































































































































































































                                <Button































































































































































































































































                                  className="button"































































































































































































































































                                  variant="success"































































































































































































































































                                  onClick={this.Rule_execution_queuesubmitHandler}































































































































































































































































                                  disabled={!this.isFormValid()}































































































































































































































































                                  style={{































































































































































































































































                                    marginTop: "20px",































































































































































































































































                                  }}































































































































































































































































                                >































































































































































































































































                                  Save































































































































































































































































                                </Button>































































































































































































































































                              </Col>































































































































































































































































                            </Row>































































































































































































































































                          </Container>































































































































































































































































                        </Offcanvas.Body>































































































































































































































































                      </Offcanvas>































































































































































































































































































































































































































































































































                      {/* Enhanced Edit Offcanvas */}































































































































































































































































                      {this.state.isEditing && (































































































































































































































































                        <Offcanvas































































































































































































































































                          show={this.state.isEditing}































































































































































































































































                          onHide={this.handleOffcanvasClose}































































































































































































































































                          {...this.props}































































































































































































































































                          style={{ width: "500px" }}































































































































































































































































                          placement="end"































































































































































































































































                          backdrop="true"































































































































































































































































                        >































































































































































































































































                          <Offcanvas.Header closeButton>































































































































































































































































                            <Offcanvas.Title>Edit Rule_execution_queue</Offcanvas.Title>































































































































































































































































                          </Offcanvas.Header>































































































































































































































































                          <Offcanvas.Body>































































































































































































































































                            <Container style={{ "overflowY": "auto", height: "auto" }}>































































































































































































































































































































































































































































































































                              {/* Error Summary */}































































































































































































































































                              {Object.keys(errors).length > 0 && (































































































































































































































































                                <div className="alert alert-danger mb-3">































































































































































































































































                                  <strong>Please fix the following errors:</strong>































































































































































































































































                                  <ul className="mb-0 mt-2">































































































































































































































































                                    {Object.entries(errors).map(([field, error]) => (































































































































































































































































                                      <li key={field}>{error}</li>































































































































































































































































                                    ))}































































































































































































































































                                  </ul>































































































































































































































































                                </div>































































































































































































































































                              )}































































































































































































































































































































































































































































































































                              <Row className="divstyle">































































































































































































































































                                <Row>































































































































































































































































                                  <Form>































































































































































































































































                                    <Row>































































































































































































































































                                      <Col lg="4" md="4">































































































































































































































































                                        <Form.Label style={{ paddingTop: "8px" }}>Table Name</Form.Label>































































































































































































































































                                      </Col>































































































































































































































































                                      <Col lg="8" md="8">































































































































































































































































                                        <Form.Control type="text" onChange={this.handletable_nameChange} className="form-control" name="table_name" value={this.state.table_name} required="required" placeholder="Enter Table Name" />































































































































































































































































                                      </Col>































































































































































































































































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.table_name} </div>































































































































































































































































                                    </Row><br /><Row>































































































































































































































































                                      <Col lg="4" md="4">































































































































































































































































                                        <Form.Label style={{ paddingTop: "8px" }}>Trigger Event</Form.Label>































































































































































































































































                                      </Col>































































































































































































































































                                      <Col lg="8" md="8">































































































































































































































































                                        <Form.Control type="text" onChange={this.handletrigger_eventChange} className="form-control" name="trigger_event" value={this.state.trigger_event} required="required" placeholder="Enter Trigger Event" />































































































































































































































































                                      </Col>































































































































































































































































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.trigger_event} </div>































































































































































































































































                                    </Row><br /><Row>































































































































































































































































                                      <Col lg="4" md="4">































































































































































































































































                                        <Form.Label style={{ paddingTop: "8px" }}>Rule Id</Form.Label>































































































































































































































































                                      </Col>































































































































































































































































                                      <Col lg="8" md="8">































































































































































































































































                                        <Form.Control type="number" onChange={this.handlerule_idChange} className="form-control" name="rule_id" value={this.state.rule_id} required="required" placeholder="Enter Rule Id" />































































































































































































































































                                      </Col>































































































































































































































































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.rule_id} </div>































































































































































































































































                                    </Row><br /><Row>































































































































































































































































                                      <Col lg="4" md="4">































































































































































































































































                                        <Form.Label style={{ paddingTop: "8px" }}>Parameters</Form.Label>































































































































































































































































                                      </Col>































































































































































































































































                                      <Col lg="8" md="8">































































































































































































































































                                        <Form.Control type="text" onChange={this.handleparametersChange} className="form-control" name="parameters" value={this.state.parameters} required="required" placeholder="Enter Parameters" />































































































































































































































































                                      </Col>































































































































































































































































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.parameters} </div>































































































































































































































































                                    </Row><br /><Row>































































































































































































































































                                      <Col lg="4" md="4">































































































































































































































































                                        <Form.Label style={{ paddingTop: "8px" }}>Priority</Form.Label>































































































































































































































































                                      </Col>































































































































































































































































                                      <Col lg="8" md="8">































































































































































































































































                                        <select className="form-select" name="tableName" onChange={this.handlepriorityChange}>































































































































































































































































                                          <option defaultValue> Select Priority </option>































































































































































































































































                                          {this.state.testcaseprioritymaster.map((api, index, idx) => (































































































































































































































































                                            <option key={index} value={api.low}> {api.low} </option>































































































































































































































































                                          ))}































































































































































































































































                                        </select>































































































































































































































































                                      </Col>































































































































































































































































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.priority} </div>































































































































































































































































                                    </Row><br /><Row>































































































































































































































































                                      <Col lg="4" md="4">































































































































































































































































                                        <Form.Label style={{ paddingTop: "8px" }}>Status</Form.Label>































































































































































































































































                                      </Col>































































































































































































































































                                      <Col lg="8" md="8">































































































































































































































































                                        <select className="form-select" name="tableName" onChange={this.handlestatusChange}>































































































































































































































































                                          <option defaultValue> Select Status </option>































































































































































































































































                                          {this.state.testcasestatusmaster.map((api, index, idx) => (































































































































































































































































                                            <option key={index} value={api.pending}> {api.pending} </option>































































































































































































































































                                          ))}































































































































































































































































                                        </select>































































































































































































































































                                      </Col>































































































































































































































































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.status} </div>































































































































































































































































                                    </Row><br /><Row>































































































































































































































































                                      <Col lg="4" md="4">































































































































































































































































                                        <Form.Label style={{ paddingTop: "8px" }}>Attempts</Form.Label>































































































































































































































































                                      </Col>































































































































































































































































                                      <Col lg="8" md="8">































































































































































































































































                                        <Form.Control type="number" onChange={this.handleattemptsChange} className="form-control" name="attempts" value={this.state.attempts} required="required" placeholder="Enter Attempts" />































































































































































































































































                                      </Col>































































































































































































































































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.attempts} </div>































































































































































































































































                                    </Row><br /><Row>































































































































































































































































                                      <Col lg="4" md="4">































































































































































































































































                                        <Form.Label style={{ paddingTop: "8px" }}>Result</Form.Label>































































































































































































































































                                      </Col>































































































































































































































































                                      <Col lg="8" md="8">































































































































































































































































                                        <Form.Control type="text" onChange={this.handleresultChange} className="form-control" name="result" value={this.state.result} required="required" placeholder="Enter Result" />































































































































































































































































                                      </Col>































































































































































































































































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.result} </div>































































































































































































































































                                    </Row><br /><Row>































































































































































































































































                                      <Col lg="4" md="4">































































































































































































































































                                        <Form.Label style={{ paddingTop: "8px" }}>Error Message</Form.Label>































































































































































































































































                                      </Col>































































































































































































































































                                      <Col lg="8" md="8">































































































































































































































































                                        <Form.Control type="text" onChange={this.handleerror_messageChange} className="form-control" name="error_message" value={this.state.error_message} required="required" placeholder="Enter Error Message" />































































































































































































































































                                      </Col>































































































































































































































































                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.error_message} </div>































































































































































































































































                                    </Row><br />































































































































































































































































                                    {/* Auto-generated form content with validation */}































































































































































































































































                                  </Form>































































































































































































































































                                </Row>































































































































































































































































                              </Row>































































































































































































































































                              <Row>































































































































































































































































                                <Col































































































































































































































































                                  className="d-flex justify-content-end"































































































































































































































































                                  style={{ marginRight: "50px" }}































































































































































































































































                                >































































































































































































































































                                  <Button































































































































































































































































                                    className="button"































































































































































































































































                                    variant="success"































































































































































































































































                                    onClick={this.Rule_execution_queueupdateHandler}































































































































































































































































                                    disabled={!this.isFormValid()}































































































































































































































































                                    style={{































































































































































































































































                                      marginTop: "20px",































































































































































































































































                                    }}































































































































































































































































                                  >































































































































































































































































                                    Update































































































































































































































































                                  </Button>































































































































































































































































                                </Col>































































































































































































































































                              </Row>































































































































































































































































                            </Container>































































































































































































































































                          </Offcanvas.Body>































































































































































































































































                        </Offcanvas>































































































































































































































































                      )}































































































































































































































































                      {/*offcanvas is over */}































































































































































































































































                    </Col>































































































































































































































































                  </Row>































































































































































































































































                  <br />































































































































































































































































                  <Row>































































































































































































































































                    <div style={{ "marginRight": "5px" }}>































































































































































































































































                      {/* searchbar,pagination,filter */}































































































































































































































































                      <input































































































































































































































































                        type="text"































































































































































































































































                        style={{ float: "left", marginBottom: "10px" }}































































































































































































































































                        onChange={this.handleFilter}































































































































































































































































                        placeholder="Search..."































































































































































































































































                      />































































































































































































































































                      <DataTable































































































































































































































































                        data={paginatedData}































































































































































































































































                        columns={this.state.tableClms}































































































































































































































































                        pagination































































































































































































































































                        paginationServer































































































































































































































































                        paginationTotalRows={































































































































































































































































                          this.state.filteredData































































































































































































































































                            ? this.state.filteredData.length































































































































































































































































                            : this.state.data.length































































































































































































































































                        }































































































































































































































































                        onChangeRowsPerPage={this.handlePerRowsChange}































































































































































































































































                        onChangePage={this.handlePageChange}































































































































































































































































                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}































































































































































































































































                        keyField="id"































































































































































































































































                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"































































































































































































































































                      />































































































































































































































































                    </div>































































































































































































































































                  </Row>































































































































































































































































































































































































































































































































                </div>































































































































































































































































              </div>































































































































































































































































            </div>































































































































































































































































          </div>































































































































































































































































        </div>































































































































































































































































      </div>































































































































































































































































































































































































































































































































    );































































































































































































































































  }































































































































































































































































}